module.exports = __webpack_public_path__ + "img/w3_delivery_grey.eeb12744.png";